import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const PermissionDomainName_AdvisorLaunch = 'Advisor Launch';
export const PermissionKeys_AdvisorLaunch = generateKeyNamesByAccessLevel(PermissionDomainName_AdvisorLaunch, defaultUIAccessLevels);
//# sourceMappingURL=ui.js.map